import React from 'react'
import CustomModal from '../common/modal'
import Button from '../common/button'
import ErrorImg from "../../assets/images/error.png"
import "./index.scss"

const WarningModal = ({ img, title, subtitle, btnText, onClickHandler, handleModal, show }) => {
  return (
    <CustomModal
        show={show}
        handleClose={handleModal}
      >
        <div className='warning--card'>
          <img src={img ? img : ErrorImg} alt='error'/>
          <h2 className='warning--title'>
            {title}
          </h2>
          <p className='warning--subtitle'>
            {subtitle}
          </p>
          <div className="warning-footer">
            <Button variant="primaryBox" onClick={onClickHandler} label={btnText}>
              {btnText}
            </Button>
          </div>
        </div>
      </CustomModal>
  )
}

export default WarningModal